"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultValue_1 = require("./defaultValue");
var checkType_1 = require("./checkType");
function setData(schema, data, value, path, pathIndex, Vue, fixArraySize) {
    if (pathIndex === void 0) { pathIndex = 0; }
    if (path !== undefined) {
        if (typeof path === 'string') {
            path = path
                .replace(/\[/g, '.')
                .replace(/\]/g, '')
                .split('.')
                .filter(function (x) { return x; });
            pathIndex = 0;
        }
        var cpath = path[pathIndex];
        if (cpath) {
            if (schema.type === 'object') {
                var dschema = schema.properties[cpath];
                if (dschema !== undefined) {
                    if (dschema.type === 'object' || dschema.type === 'array') {
                        var data2 = data[cpath];
                        if (data2 === undefined) {
                            data2 = defaultValue_1.default(dschema, true);
                            if (Vue) {
                                Vue.set(data, cpath, data2);
                            }
                            else {
                                data[cpath] = data2;
                            }
                        }
                        return setData(dschema, data2, value, path, pathIndex + 1, Vue, fixArraySize);
                    }
                    else {
                        return setDataValue(dschema, data, cpath, value, Vue);
                    }
                }
                else {
                    return false;
                }
            }
            else if (schema.type === 'array') {
                var dschema = schema.items;
                if (dschema !== undefined) {
                    var index = parseInt(cpath, 10);
                    var data2 = data[index];
                    if (data2 === undefined) {
                        while (data.length < index + 1) {
                            data.push(defaultValue_1.default(dschema, true));
                        }
                        // data2 = data[index];
                    }
                    if (dschema.type === 'array' || dschema.type === 'object') {
                        return setData(dschema, data[index], value, path, pathIndex + 1, Vue, fixArraySize);
                    }
                    else {
                        return setDataValue(dschema, data, index, value, Vue);
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    if (schema.type === 'object') {
        return setDataObj(schema, data, value, Vue, fixArraySize);
    }
    else {
        return setDataArray(schema, data, value, Vue, fixArraySize);
    }
}
exports.default = setData;
function setDataValue(schema, parent, key, value, Vue) {
    if (checkType_1.default(schema, value)) {
        if (Vue) {
            Vue.set(parent, key, value);
            parent[key] = value;
        }
        else {
            parent[key] = value;
        }
        return true;
    }
    return false;
}
exports.setDataValue = setDataValue;
function setDataArray(schema, destArray, value, Vue, fixArraySize) {
    var sitems = schema.items;
    if (fixArraySize) {
        while (destArray.length > value.length) {
            destArray.splice(destArray.length - 1, 1);
        }
    }
    for (var i = 0; i < value.length; i++) {
        var nitem = destArray[i];
        if (nitem === undefined) {
            nitem = defaultValue_1.default(sitems, true);
            if (i > destArray.length - 1) {
                destArray.push(nitem);
            }
            else {
                if (Vue) {
                    Vue.set(destArray, i, nitem);
                }
                else {
                    destArray[i] = nitem;
                }
            }
        }
        switch (sitems.type) {
            case 'object':
                setDataObj(sitems, nitem, value[i], Vue, fixArraySize);
                break;
            case 'array':
                setDataArray(sitems, nitem, value[i], Vue, fixArraySize);
                break;
            default:
                if (i > destArray.length - 1) {
                    destArray.push(value[i]);
                }
                else {
                    if (Vue) {
                        Vue.set(destArray, i, value[i]);
                    }
                    else {
                        destArray[i] = value[i];
                    }
                }
                break;
        }
    }
    return true;
}
function setDataObj(schema, parentObject, value, Vue, fixArraySize) {
    var props = schema.properties;
    for (var key in value) {
        if (value.hasOwnProperty(key)) {
            var pschema = props[key];
            if (pschema !== undefined) {
                var kvalue = value[key];
                switch (pschema.type) {
                    case 'object':
                        if (kvalue === null) {
                            setDataValue(pschema, parentObject, key, null, Vue);
                            continue;
                        }
                        var nparent = parentObject[key];
                        if (nparent === undefined || nparent === null) {
                            setDataValue(pschema, parentObject, key, defaultValue_1.default(pschema) || {}, Vue);
                            nparent = parentObject[key];
                        }
                        setDataObj(pschema, nparent, kvalue, Vue, fixArraySize);
                        break;
                    case 'array':
                        if (kvalue === null) {
                            setDataValue(pschema, parentObject, key, null, Vue);
                            continue;
                        }
                        var narray = parentObject[key];
                        if (narray === undefined || narray === null) {
                            parentObject[key] = narray = defaultValue_1.default(pschema);
                        }
                        setDataArray(pschema, narray, kvalue, Vue, fixArraySize);
                        break;
                    default:
                        setDataValue(pschema, parentObject, key, kvalue, Vue);
                        break;
                }
            }
        }
    }
    return true;
}
function setDataKey(schema, parent, key, value) {
    if (schema.type === 'object') {
        if (typeof value === 'object') {
            var destobj = parent[key];
            if (destobj === undefined) {
                parent[key] = destobj = defaultValue_1.default(schema, true);
            }
            var keys = Object.keys(value);
            var props = schema.properties;
            var dkeys = Object.keys(props);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var skey = keys_1[_i];
                var dschema = props[skey];
                if (dschema !== undefined) {
                    setData(dschema, destobj, skey, value[skey]);
                }
            }
            return true;
        }
        else {
            return false;
        }
    }
    else if (schema.type === 'array') {
        if (Array.isArray(value)) {
            var destobj = parent[key];
            if (destobj === undefined) {
                parent[key] = destobj = defaultValue_1.default(schema, true);
            }
            var items = schema.items;
            for (var i = 0; i < value.length; i++) {
                setData(items, destobj, i, value[i]);
            }
            return true;
        }
        else {
            return false;
        }
    }
    else {
        switch (schema.type) {
            case 'integer':
            case 'number':
            case 'money':
                if (typeof value === 'number') {
                    parent[key] = value;
                    return true;
                }
                else {
                    return false;
                }
            case 'string':
                if (typeof value === 'string') {
                    parent[key] = value;
                    return true;
                }
                else {
                    return false;
                }
            case 'boolean':
                if (typeof value === 'boolean') {
                    parent[key] = value;
                    return true;
                }
                else {
                    return false;
                }
            default:
                return false;
        }
    }
}
//# sourceMappingURL=setData.js.map